import { getToken,axiosInstance } from "../../utils/Api";
export const createQuizAsset = async (formdata) =>{ 
    try {
        const response = await axiosInstance.post("/admin/assets/assetCreate",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response?.data;
      } catch (error) {
        throw error;
      } 
} 
export const deleteAssetByID = async (inputData) => {
    try {
      const response = await axiosInstance.delete(`/admin/assets/assetDelete`, {
          data: inputData,
          headers: {
              Authorization: `Bearer ${getToken()}`,
          },
      });
        return response?.data;
      } catch (error) {
           console.error('Error in delete Asset:', error);
          return false;
      }
  };
  export const UpdateAsset = async (formdata) => {
    try {
       const response = await axiosInstance.put(`/admin/assets/assetUpdate`,formdata,{                
                      
            headers: {
               'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response?.data;
      } catch (error) {
           console.error('Error in update Asset:', error);
          return false;
      }
  };
  export const getAssetDataByID = async (assetID) => {
    try {
    //    const response = await axiosInstance.get(`${cmsUserUrl}/quiz/assetPlay/${assetID}`,{                
    //         headers: {
    //             Authorization: `Bearer ${getToken()}`,
    //         },
    //     });
    //     return response?.data;
       const response = await axiosInstance.get(`/admin/assets/assetPlay/${assetID}`,{                
                   
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response?.data;
      } catch (error) {
           console.error('Error in get Asset:', error);
          return false;
      }
  };  
    